import React from "react";
import { Card, CardContent } from "../ui/card";
import { cn } from "../../lib/utils";

export function KpiCard({ title, value, icon: Icon, hint, testId, accent = false, loading = false }) {
  return (
    <Card data-testid={testId} className="animate-slide-in-bottom">
      <CardContent className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="text-xs font-semibold uppercase tracking-wide text-text-muted">{title}</p>
            {loading ? (
              <div className="mt-2 h-8 w-20 animate-pulse rounded bg-border/70" />
            ) : (
              <p className="mt-2 truncate font-heading text-3xl font-bold text-text-main">{value}</p>
            )}
            {hint && <p className="mt-1 truncate text-xs text-text-muted">{hint}</p>}
          </div>
          {Icon && (
            <div
              className={cn(
                "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md",
                accent ? "bg-accent/20 text-primary" : "bg-primary/10 text-primary"
              )}
            >
              <Icon size={20} strokeWidth={1.5} />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
